import { Component, Host, h, Element } from '@stencil/core';

export interface AhaBreadcrumbs extends HTMLAhaBreadcrumbsElement {}

/**
 * Custom breadcrumbs component that implements `aha-breadcrumb` and adds automatically the `first-child` attribute to the first `aha-breadcrumb`
 * @slot default - Contents of the default slot.
 */
@Component({
  tag: 'aha-breadcrumbs',
  styleUrl: 'aha-breadcrumbs.css',
  shadow: true,
})
export class AhaBreadcrumbs {
  @Element() host!: HTMLAhaBreadcrumbsElement;

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
